var map = {
	"./1.svg": 5474,
	"./10.svg": 3905,
	"./11.svg": 6190,
	"./12.svg": 3,
	"./13.svg": 2692,
	"./14.svg": 2710,
	"./15.svg": 8877,
	"./16.svg": 4651,
	"./17.svg": 6809,
	"./18.svg": 305,
	"./2.svg": 3660,
	"./3.svg": 684,
	"./4.svg": 7065,
	"./5.svg": 5457,
	"./6.svg": 4865,
	"./7.svg": 7231,
	"./8.svg": 7562,
	"./9.svg": 462
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3020;